import RadioGroup from "../../../general/input/radio/RadioGroup";
import Radio from "../../../general/input/radio/Radio";
import LoadingSwitcher from "../../../general/loading/LoadingSwitcher";
import useCheckoutStore from "../../../../cart/store/checkoutStore";
import {useState} from "react";

const CartBankPicker = () => {

    const institutionId = useCheckoutStore(state => state.input?.institutionId);
    const setInstitution = useCheckoutStore(state => state.setInstitution);
    const institutions = useCheckoutStore(state => state.institutions);
    const loading = useCheckoutStore(state => state.loading?.institutions);
    const error = useCheckoutStore(state => state.error?.institutions);

    const [filter, setFilter] = useState("");

    const filtered = filter && institutions
        ? institutions.filter(i => i.fullName.toLowerCase().includes(filter.toLowerCase()))
        : (institutions || []);

    return (
        <>
            <p className="cart-h">Select Your Bank</p>
            <LoadingSwitcher loading={!!loading}>
                {error && <p className="cart-blocker">{error}</p>}
                {!error && institutions && institutions.length > 0 && (
                    <>
                        {institutions.length > 5 && (
                            <input
                                type="text"
                                placeholder="Search banks..."
                                value={filter}
                                onChange={e => setFilter(e.target.value)}
                                style={{
                                    width: "100%",
                                    maxWidth: 400,
                                    padding: "8px 12px",
                                    marginBottom: 12,
                                    border: "1px solid #ccc",
                                    borderRadius: 4,
                                    fontSize: 14,
                                }}
                            />
                        )}
                        <RadioGroup>
                            {filtered.map(inst => (
                                <Radio
                                    key={inst.id}
                                    isSelected={institutionId === inst.id}
                                    onSelected={() => setInstitution(inst.id)}
                                >
                                    <div style={{display: "flex", alignItems: "center", gap: 10}}>
                                        {inst.icon &&
                                            <img
                                                src={inst.icon}
                                                alt={inst.fullName}
                                                style={{width: 24, height: 24, objectFit: "contain"}}
                                            />
                                        }
                                        <span>{inst.fullName}</span>
                                    </div>
                                </Radio>
                            ))}
                        </RadioGroup>
                        {filtered.length === 0 && (
                            <p>No banks match your search.</p>
                        )}
                    </>
                )}
                {!error && (!institutions || institutions.length === 0) && !loading && (
                    <p>No banks available.</p>
                )}
            </LoadingSwitcher>
        </>
    );
};

export default CartBankPicker;
